import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import Dec from 'decimal.js';
import { reset } from 'redux-form';
import configJson from '../../config/config.json';
import { CREATE_HPOOL_STEPS, MAX_POOL_ALLOCATION, CREATE_HPOOL_ACTIONS } from '../../constants/createHPool';
import { getAssetPriceAction, getAssetBalanceAction } from './assetsActions';
import {
  CREATE_HPOOL_ADD_TOKEN,
  MANAGE_HPOOL_REPLACE_TOKENS,
  CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE,
  CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE,
  CREATE_HPOOL_DELETE_TOKEN,
  CREATE_HPOOL_SEARCH_TOKENS_FAILURE,
  CREATE_HPOOL_SEARCH_TOKENS_REQUEST,
  CREATE_HPOOL_SEARCH_TOKENS_SUCCESS,
  MANAGE_HPOOL_TAG,
  SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH,
  SET_CREATE_HPOOL_STEP_FINISHED,
  SET_CREATE_TICKETS_ALERT,
  SET_CHOOSE_TOKENS_ALERT,
  GET_CHAMPION_NFT_IMAGE_REQUEST,
  GET_CHAMPION_NFT_IMAGE_SUCCESS,
  GET_CHAMPION_NFT_IMAGE_FAILURE,
  SUBMIT_CREATE_HPOOL_REQUEST,
  SUBMIT_CREATE_HPOOL_SUCCESS,
  SUBMIT_CREATE_HPOOL_FAILURE,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS,
  GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE,
  GET_CHAMPION_NFT_REQUEST,
  GET_CHAMPION_NFT_SUCCESS,
  GET_CHAMPION_NFT_FAILURE,
  UPDATE_CHAMPION_NFT_REQUEST,
  UPDATE_CHAMPION_NFT_SUCCESS,
  UPDATE_CHAMPION_NFT_FAILURE,
  GET_CHAMPION_DRAFT_POOL_REQUEST,
  GET_CHAMPION_DRAFT_POOL_SUCCESS,
  GET_CHAMPION_DRAFT_POOL_FAILURE,
  CREATE_UPDATE_HPOOL_REQUEST,
  CREATE_UPDATE_HPOOL_FAILURE,
  CREATE_UPDATE_HPOOL_SUCCESS,
  GET_TAGS_REQUEST,
  GET_TAGS_FAILURE,
  GET_TAGS_SUCCESS,
  UPDATE_TAGS,
  GET_HPOOL_SUCCESS,
  DEPOSIT_HPOOL_SUCCESS,
  DEPOSIT_HPOOL_FAILURE,
  DEPOSIT_HPOOL_REQUEST,
  SET_ASSET_SIGNATURES,
  UPDATE_HPOOL,
  GET_TICKET_INFO_REQUEST,
  GET_TICKET_INFO_SUCCESS,
  GET_TICKET_INFO_FAILURE,
  GET_MIN_DEPOSIT_VALUE_REQUEST,
  GET_MIN_DEPOSIT_VALUE_SUCCESS,
  GET_MIN_DEPOSIT_VALUE_FAILURE,
  ASSIGN_HPOOL_NFT_REQUEST,
  ASSIGN_HPOOL_NFT_SUCCESS,
  ASSIGN_HPOOL_NFT_FAILURE,
  GET_INIT_DEPO_REQUEST,
  GET_INIT_DEPO_SUCCESS,
  GET_INIT_DEPO_FAILURE,
  RESET_CREATE_HPOOL_ERROR_MESSAGE,
  GET_HPOOL_REQUEST,
  CLEAR_HPOOL_DRAFT,
  SET_CURRENT_TAB,
  UPDATE_TRADE_ORDERS,
  FETCH_MOST_USED_TOKENS_REQUEST,
  FETCH_MOST_USED_TOKENS_SUCCESS,
  FETCH_MOST_USED_TOKENS_FAILURE,
  SET_HPOOL_STATS_SUCCESS,
  SET_HPOOL_STATS_REQUEST,
  SET_HPOOL_STATS_FAILURE,
  SET_WHITELISTED_POOLS,
  SET_VPOOL_FLAG,
  UPDATE_BASE_TOKENS,
  GET_HPOOL_SAFTS_REQUEST,
  GET_HPOOL_SAFTS_FAILURE,
  GET_HPOOL_SAFTS_SUCCESS,
  SET_HAS_COMPLETED_SAFTS_STEP,
} from '../actionTypes/createHPoolActionTypes';
import { ethToWei } from '../../services/web3Service';
import {
  createHPoolHandleTokenDelete,
  createHPoolHandleTokenPercentageChange,
  createOrUpdateHPool,
  // createHPoolSearchTokens,
  findTokenToAddConditional,
  getChampionNftImage,
  submitCreateHPool,
  getTokensList,
  getChampionUnattachedNFT,
  getDraftHPoolForChampion,
  updateChampionUnattachedNFT,
  assignNFTToHPool,
  getHPool,
  getTags,
  depositHPool,
  getTicketsInfo,
  getMinDepositValue,
  getHpoolInfo,
  getBaseToken,
  fetchMostUsedTokensRequest,
  getPoolSafts,
} from '../../services/createHPoolService';
import { getTikcetsInfo } from '../../services/nftService';
import { assetAmountInEth, assetAmountInWei } from '../../services/assetsService';
import { createNotification, startAction, stopAction } from './uiActions';
import { getValueByMultiProps, getValueByMultiPropsLowerCased } from '../../utils/mapper';
import { wait } from '../../services/utilsService';
import { checksumAddress, getAccount } from '../../services/walletService';
import { getHpoolStats } from '../../services/hpoolService';
import { getWhitelisteSignature, getWhitelistedPoolsForUser } from '../../services/vpoolService';
// import { openEditTokensModal } from './modalActions';
// import { UPDATED_HPOOL_LIST_STAGE } from '../../constants/hpool';
/**
 * Handles the redux state for adding/removing tags from the pool info step
 *
 * @param tag {Object}
 * @param action {String}
 * @returns {(function(*, *): void)|*}
 */
export const manageHpoolTagAction =
  (tag, action = 'all') =>
  (dispatch, getState) => {
    let tags = [...getState().createHPool.tags];

    if (action === 'all') tags = [...tag];
    if (action === 'add') tags.push(tag);
    if (action === 'remove') tags = tags.filter(({ value }) => value !== tag.value);

    dispatch({ type: MANAGE_HPOOL_TAG, payload: tags });
  };

export const directTagsManage = (tags) => (dispatch, getState) => {
  dispatch({ type: MANAGE_HPOOL_TAG, payload: tags });
};

export const getHpoolStatsAction = (hpoolContractAddress) => async (dispatch, getState) => {
  try {
    if (!hpoolContractAddress) return;
    dispatch({ type: SET_HPOOL_STATS_REQUEST });
    const { stats } = await getHpoolStats(hpoolContractAddress);
    dispatch({ type: SET_HPOOL_STATS_SUCCESS, payload: stats });
  } catch (error) {
    dispatch({ type: SET_HPOOL_STATS_FAILURE, error });
  }
};

/**
 * Dismisses the alter box on the create tickets step
 *
 * @returns {(function(*): void)|*}
 */
export const setCreateTicketsAlertAction = () => (dispatch) => {
  localStorage.setItem('createTicketsAlert', 'false');
  dispatch({ type: SET_CREATE_TICKETS_ALERT });
};

/**
 * Dismisses the alter box on the choose tokens step
 *
 * @returns {(function(*): void)|*}
 */
export const setChooseTicketsAlertAction = () => (dispatch) => {
  localStorage.setItem('chooseTokensAlert', 'false');
  dispatch({ type: SET_CHOOSE_TOKENS_ALERT });
};

const getFormValues = (state, form) => state.form[form]?.values || {};

export const setSaftStepCompleted = () => (dispatch) => {
  dispatch({ type: SET_HAS_COMPLETED_SAFTS_STEP });
};

export const createOrUpdateHPoolAction =
  (body, cb = () => {}) =>
  async (dispatch, getState) => {
    const isVpool = getState().createHPool?.isVpool;

    try {
      dispatch({ type: CREATE_UPDATE_HPOOL_REQUEST });
      const response = await createOrUpdateHPool(body, isVpool);
      const payload = {
        hpool: response.hpool,
        tradeOrders: response.pending_market_trade_orders
          ? response.pending_market_trade_orders
          : response.trade_orders
          ? response.trade_orders
          : [],
      };
      dispatch({ type: CREATE_UPDATE_HPOOL_SUCCESS, payload });
      cb();
    } catch (err) {
      const errorMsg = err || err?.message;
      dispatch(createNotification('error', errorMsg, 4000));
      dispatch({ type: CREATE_UPDATE_HPOOL_FAILURE, payload: err.message });
    }
  };

export const poolForUnattachedNFT = async (championId, { timeout = 10 * 60 * 1000, interval = 30 * 1000 } = {}) => {
  let res = await getChampionUnattachedNFT(championId);
  if (!res.nft || res.nft.minted) {
    return res;
  }
  let timedOut = false;
  const fallbackTimeout = setTimeout(() => {
    timedOut = true;
    clearTimeout(fallbackTimeout);
    throw new Error('Getting NFT timeout!');
  }, timeout);
  while (!res.nft?.minted && !timedOut) {
    /* eslint-disable no-await-in-loop */
    await wait(interval);
    res = await getChampionUnattachedNFT(championId);
    /* eslint-enable no-await-in-loop */
    if (res.nft?.minted) {
      clearTimeout(fallbackTimeout);
      return res;
    }
  }
};

// usage: await dispatch(validateChampionAddress())
export const validateChampionAddress = () => async (dispatch, getState) => {
  const championAddress = getState().createHPool.hpool?.champion_active_web3_address;
  if (!championAddress) {
    throw new Error('Missing champion active address!');
  }
  const account = await getAccount();
  if (!account || account.toLowerCase() !== championAddress.toLowerCase()) {
    throw new Error(`Please switch to ${checksumAddress(championAddress)}`);
  }
};

export const getChampionUnattachedNFTAction = () => async (dispatch, getState) => {
  dispatch({ type: GET_CHAMPION_NFT_REQUEST });

  try {
    const { nft: payload } = await poolForUnattachedNFT(getState().champion.championData?.champion_id);
    // await getChampionUnattachedNFT(getState().champion.championData?.champion_id);
    // if (payload?.id) {
    //   const [reservedTickets, totalTickets] = await getTikcetsInfo(payload?.id);
    //   payload.reservedTickets = reservedTickets;
    //   payload.totalTickets = totalTickets;
    // }

    dispatch({ type: GET_CHAMPION_NFT_SUCCESS, payload });
    return payload;
  } catch (err) {
    dispatch({ type: GET_CHAMPION_NFT_FAILURE, payload: err.message });
  }
};

export const getDraftHPoolForChampionAction = (passedResponse) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_CHAMPION_DRAFT_POOL_REQUEST });
    const response = passedResponse || (await getDraftHPoolForChampion());

    const { hpool, hpool_nft_image_url: nftImage } = response;
    const tradeOrders = response.pending_market_trade_orders
      ? response.pending_market_trade_orders
      : response.trade_orders
      ? response.trade_orders
      : [];
    const hpoolWithNftImage = {
      ...hpool,
      nftImage,
    };
    const payload = {
      hpool: hpoolWithNftImage,
      tradeOrders,
    };
    await dispatch(getChampionUnattachedNFTAction());
    dispatch({ type: GET_CHAMPION_DRAFT_POOL_SUCCESS, payload });
    return payload;
  } catch (err) {
    dispatch({ type: GET_CHAMPION_DRAFT_POOL_FAILURE, payload: err });
  }
};

export const assignNFTToHPoolAction =
  ({ nft_id: nftId, hpool_id: hPoolId }) =>
  async (dispatch) => {
    console.log('assignNFTToHPoolAction', nftId, hPoolId);
    try {
      if (nftId && hPoolId) {
        dispatch({ type: ASSIGN_HPOOL_NFT_REQUEST });
        const payload = await assignNFTToHPool({ nft_id: nftId, hpool_id: hPoolId });
        dispatch({ type: ASSIGN_HPOOL_NFT_SUCCESS });
      }
    } catch (err) {
      dispatch({ type: ASSIGN_HPOOL_NFT_FAILURE });
    }
  };

export const depositFundsAction =
  (hpool, onSuccess = () => {}) =>
  async (dispatch, getState) => {
    dispatch({ type: DEPOSIT_HPOOL_REQUEST });

    try {
      console.log('depositFundsAction', hpool);
      if (hpool.draft_finished) {
        await dispatch(createOrUpdateHPoolAction(hpool));
      }
      const updateDepositTxMeta = (txHash, status) => {
        console.log('updateDepositTxMeta', { txHash, status });
        const body = {
          id: getState().createHPool.hpool?.id,
        };

        if (txHash) {
          body.champion_deposit_tx_hash = txHash;
        }
        if (typeof status === 'boolean') {
          body.champion_deposit_tx_status = status ? 1 : 0;
          dispatch(
            createOrUpdateHPoolAction(body, () => {
              // only call onSuccess after champion_deposit_tx_status is true
              if (body.champion_deposit_tx_status) onSuccess();
            }),
          );
        }
        return body;
      };
      dispatch({ type: DEPOSIT_HPOOL_REQUEST });

      const depositConfig = {
        id: hpool.id,
        amountWei: assetAmountInWei(hpool.depositAmountETH),
        account: getState().wallet.account,
        onTxHashCallback: updateDepositTxMeta,
        isVpool: getState().createHPool?.isVpool,
      };
      const receipt = await depositHPool(depositConfig);
      const response = await updateDepositTxMeta(receipt?.transactionHash, receipt?.status);
    } catch (err) {
      dispatch({ type: DEPOSIT_HPOOL_FAILURE, payload: err });
      throw err;
    }
  };

const getObjDifference = (prev, current) => {
  let diff = {};
  Object.entries(current).forEach(([key, value]) => {
    if ((isObject(value) || isArray(value)) && isEqual(value, prev?.[key])) return;
    if (prev?.[key] === value || !value) return;
    diff = { ...diff, [key]: value };
  });
  return diff;
};

const formatObj = (obj = {}, newKeys = { prevKey: 'newKey' }) => {
  let newObj = {};
  Object.keys(obj).forEach((key) => {
    const newKey = newKeys?.[key] || key;
    newObj = { ...newObj, [newKey]: obj?.[key] };
  });
  return newObj;
};

const reduceArrayToString = (array = [], key = 'label') =>
  array.map((elem) => getValueByMultiProps(elem, ['name', 'label'])).join(',');
const separatedByComma = (string = '') => string?.split(',') || [];

const getTagsData = (prevTagsString, currentTagsString) => {
  const prevTags = separatedByComma(prevTagsString);
  const currentTags = separatedByComma(currentTagsString);
  const deleteTags = currentTags.filter((tag) => !prevTags.includes(tag));
  const addTags = prevTags.filter((tag) => !currentTags.includes(tag));
  return { addTags, deleteTags };
};

export const getInitialDepositAction = (web3HpoolId) => (dispatch) => {
  dispatch({ type: GET_INIT_DEPO_REQUEST });
  getHpoolInfo(web3HpoolId)
    .then((initDepo) => {
      const assetInEth = assetAmountInEth(initDepo?.[1], 'HORD');
      dispatch({ type: GET_INIT_DEPO_SUCCESS, payload: assetInEth });
    })
    .catch((err) => {
      dispatch({ type: GET_INIT_DEPO_FAILURE, payload: err });
    });
};

const getHPoolFromState = (getState) => {
  const state = getState();
  // const ticketsData = getFormValues(state, 'createHPoolCreateTicketsForm');
  const poolInfo = getFormValues(state, 'createHPoolInfoForm');
  const depositFunds = getFormValues(state, 'createHPoolDepositFundsForm');
  // const { tagsIsLoaded } = state.createHPool;
  const {
    createHPool: { addedTokens, hpool: prevHpool },
  } = state;

  const nftData = prevHpool.id
    ? {
        nft_id: state.createHPool.unattachedNFT?.nft_id,
        hpool_id: state.createHPool.hpool?.id,
      }
    : {};

  const { addTags, deleteTags } = getTagsData(
    reduceArrayToString(state.createHPool.tags),
    state.createHPool.hpool.tags_str,
  );

  const tagsData = {
    add_tags: addTags.toString(),
    delete_tags: deleteTags.toString(),
  };

  const changes = {
    ...poolInfo,
    ...nftData,
    ...depositFunds,
    ...tagsData,
    assets: addedTokens.reduce((acc, curr) => {
      if (curr.percentage) {
        acc[curr.token_id || curr.id] = curr.percentage;
      }
      return acc;
    }, {}),
  };
  delete prevHpool.add_tags;
  delete prevHpool.delete_tags;

  const foramttedChanges = formatObj(changes, {
    hPoolName: 'name',
    hPoolDescription: 'description',
    hPooltokenSymbol: 'hpool_token_symbol',
  });
  const hpool = {
    ...prevHpool,
    assets: Array.isArray(prevHpool.assets)
      ? prevHpool.assets?.reduce((acc, curr) => {
          if (curr.current_ratio_from_pool) {
            acc[curr.token_id || curr.id] = curr.current_ratio_from_pool;
          }
          return acc;
        }, {})
      : prevHpool.assets,
  };

  // send the full changes if pool is not yet created
  const diff = Number.isInteger(prevHpool.id) ? getObjDifference(hpool, foramttedChanges) : foramttedChanges;

  const id = prevHpool?.id;
  const mergedWithId = {
    ...diff,
    id,
    ...nftData,
    chain_id: window.chainId,
  };
  return mergedWithId;
};

export const clearDraft = (baseTokens) => async (dispatch) => {
  dispatch({ type: CLEAR_HPOOL_DRAFT, payload: baseTokens });
};

export const updateBaseTokens = (baseTokens) => async (dispatch) => {
  dispatch({ type: UPDATE_BASE_TOKENS, payload: baseTokens });
};
/**
 * Handles the redux state for submitting the addFunds step
 *
 * @param data {Object}
 * @param history {Object}
 * @returns {(function(*, *): Promise<*>)|*}
 */
export const submitCreateHPoolAction = (data, history) => async (dispatch, getState) => {
  dispatch(startAction());
  dispatch({ type: SUBMIT_CREATE_HPOOL_REQUEST });

  try {
    const hpool = getHPoolFromState(getState);

    await dispatch(
      depositFundsAction(hpool, () => {
        dispatch({ type: SUBMIT_CREATE_HPOOL_SUCCESS });
        dispatch({ type: DEPOSIT_HPOOL_SUCCESS });
        dispatch(reset('createHPoolCreateTicketsForm'));
        dispatch(reset('createHPoolInfoForm'));
        dispatch(reset('createHPoolDepositFundsForm'));
        if (history) {
          history.push(`/hpool/${hpool.id}`);
        }
      }),
    );
  } catch (err) {
    dispatch({ type: SUBMIT_CREATE_HPOOL_FAILURE, payload: err.message });
  } finally {
    dispatch(stopAction());
  }
};

const emptyBodyHandler = (body, baseKeys = ['id']) => {
  const bodyKeys = Object.keys(body);
  const afterFilterBaseKeys = bodyKeys.filter((key) => !baseKeys.includes(key));
  if (!afterFilterBaseKeys.length) throw new Error('Empty body');
  return afterFilterBaseKeys;
};

export const getForamattedTicketsInfo = async (nftToken) => {
  const results = await getTicketsInfo(nftToken);
  try {
    const values = results.map((response, index) => ({
      shouldBeConverted: index + 1 !== results.length,
      value: response.value,
    }));
    const afterAssetFormat = values.map((_value) =>
      _value.shouldBeConverted ? assetAmountInEth(_value.value, 'HORD') : _value.value,
    );
    const [minPoolAllocation, maxPoolAllocation, allocationPerTicket, numberOfTickets] = afterAssetFormat;
    const poolAllocation = +numberOfTickets * +allocationPerTicket;

    return { minPoolAllocation, maxPoolAllocation, allocationPerTicket, numberOfTickets, poolAllocation };
  } catch (err) {
    console.log({ err });
  }
};

export const getTicketInfoAction = (nftToken) => async (dispatch) => {
  dispatch({ type: GET_TICKET_INFO_REQUEST });
  const results = await getTicketsInfo(nftToken);
  try {
    const values = results.map((response, index) => ({
      shouldBeConverted: index + 1 !== results.length,
      value: response.value,
    }));
    const afterAssetFormat = values.map((_value) =>
      _value.shouldBeConverted ? assetAmountInEth(_value.value, 'HORD') : _value.value,
    );
    const [minPoolAllocation, maxPoolAllocation, allocationPerTicket, numberOfTickets] = afterAssetFormat;
    dispatch({
      type: GET_TICKET_INFO_SUCCESS,
      payload: {
        minPoolAllocation,
        maxPoolAllocation,
        allocationPerTicket,
        numberOfTickets,
      },
    });
  } catch (err) {
    dispatch({ type: GET_TICKET_INFO_FAILURE, payload: err });
  }
};

export const getMinDepoValueAction = () => (dispatch) => {
  dispatch({ type: GET_MIN_DEPOSIT_VALUE_REQUEST });
  getMinDepositValue()
    .then((value) => {
      dispatch({ type: GET_MIN_DEPOSIT_VALUE_SUCCESS, payload: assetAmountInEth(value, 'HORD') });
    })
    .catch((err) => {
      dispatch({ type: GET_MIN_DEPOSIT_VALUE_FAILURE, payload: err });
    });
};

export const updateTradeOrders =
  (tradeOrders = []) =>
  (dispatch) => {
    dispatch({ type: UPDATE_TRADE_ORDERS, payload: tradeOrders });
  };

export const createHPoolAction = (step) => (dispatch, getState) => {
  const hpool = getHPoolFromState(getState);
  // update current hpool with steps values so it's gonna be part of it
  dispatch({ type: UPDATE_HPOOL, payload: hpool });

  try {
    emptyBodyHandler(hpool, ['id', 'hpool_id', CREATE_HPOOL_ACTIONS.assignNFT !== step && 'nft_id']);
    switch (step) {
      case CREATE_HPOOL_ACTIONS.setSaftStepHasBeenCompleted:
        return dispatch(setSaftStepCompleted());
      case CREATE_HPOOL_ACTIONS.choosePoolType:
        return () => {};
      case CREATE_HPOOL_ACTIONS.createHPool:
      case CREATE_HPOOL_ACTIONS.updateHPool:
      case CREATE_HPOOL_ACTIONS.submitHPool:
        return dispatch(createOrUpdateHPoolAction(hpool));
      case CREATE_HPOOL_ACTIONS.nextStep:
        return () => {};
      case CREATE_HPOOL_ACTIONS.addFunds:
        return dispatch(depositFundsAction(hpool));
      case CREATE_HPOOL_ACTIONS.assignNFT:
        return dispatch(assignNFTToHPoolAction(hpool));
      default:
        return Promise.reject('Wrong action');
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * Controls what happens when clicking on the next button inside a createHPool step
 *
 * @param path {String}
 * @param history {Object}
 * @returns {(function(*): void)|*}
 */
export const createHPoolGoNextAction = (path, history) => async (dispatch, getState) => {
  const currentStepIndex = CREATE_HPOOL_STEPS.findIndex((step) => path === step.path);

  await dispatch(createHPoolAction(CREATE_HPOOL_STEPS[currentStepIndex].action));

  const errorExist = getState().createHPool?.creatingHPoolError;
  if (errorExist) return;
  const stepIscompleted = CREATE_HPOOL_STEPS[currentStepIndex].completedOn(getState().createHPool);
  if (!stepIscompleted) {
    return dispatch(
      createNotification('error', 'The step is not completed, please try again or reach out to support', 4000),
    );
  }
  dispatch({ type: SET_CREATE_HPOOL_STEP_FINISHED, payload: CREATE_HPOOL_STEPS[currentStepIndex].id });
  history.push(`/create-pool/${CREATE_HPOOL_STEPS[currentStepIndex + 1].path}`);
};

/**
 * Controls what happens when clicking on the back button inside a createHPool step
 *
 * @param path {String}
 * @param history {Object}
 * @returns {(function(*): void)|*}
 */
export const createHPoolGoBackAction = (path, history) => (dispatch) => {
  dispatch({ type: RESET_CREATE_HPOOL_ERROR_MESSAGE });

  const previousStepIndex = CREATE_HPOOL_STEPS.findIndex((step) => path === step.path) - 1;

  history.push(`/create-pool/${CREATE_HPOOL_STEPS[previousStepIndex].path}`);
};

/**
 * Gets the available tokens for the search query on the choose tokens step
 *
 * @param searchStr {String}
 * @returns {(function(*): Promise<void>)|*}
 */
export const createHPoolSearchTokensAction = (searchStr) => async (dispatch, getState) => {
  const { addedTokens } = getState().createHPool;
  const addedTokensAddress = addedTokens.reduce((acc, curr) => {
    acc[curr.address?.toLowerCase()] = curr.symbol?.toLowerCase();
    return acc;
  }, {});
  dispatch({ type: CREATE_HPOOL_SEARCH_TOKENS_REQUEST });

  try {
    const payload = (await getTokensList(searchStr)).filter(
      (resultTokens) => !addedTokensAddress[resultTokens.address.toLowerCase()],
    );

    dispatch({ type: CREATE_HPOOL_SEARCH_TOKENS_SUCCESS, payload });
  } catch (err) {
    dispatch({ type: CREATE_HPOOL_SEARCH_TOKENS_FAILURE, payload: err.message });
  }
};

/**
 * Sets the value of the input for the tokens lists search component on
 * the choose tokens step
 *
 * @param payload {String}
 * @returns {(function(*): void)|*}
 */
export const setCreateHPoolChooseTokensSearchAction = (payload) => (dispatch) => {
  dispatch({ type: SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH, payload });
  if (payload) dispatch(createHPoolSearchTokensAction(payload));
};

export const fetchMostUsedTokensAction = () => async (dispatch) => {
  dispatch({ type: FETCH_MOST_USED_TOKENS_REQUEST });
  try {
    const mostUsedTokens = await fetchMostUsedTokensRequest();
    dispatch({ type: FETCH_MOST_USED_TOKENS_SUCCESS, payload: mostUsedTokens });
  } catch (error) {
    dispatch({ type: FETCH_MOST_USED_TOKENS_FAILURE, payload: error });
  }
};
/**
 * Adds a token to the hPools list of tokens
 *
 * @param token {Object}

 * @returns {(function(*): Promise<*>)|*}
 */
export const createHPoolAddTokenFromSearchAction = (token) => async (dispatch, getState) => {
  if (getState().createHPool.addedTokens.some((addedToken) => addedToken.token_id === token.id)) {
    dispatch(createNotification('error', 'You already added this token', 4000));
    return;
  }
  // dispatch(setCreateHPoolChooseTokensSearchAction(''));
  // dispatch({ type: CREATE_HPOOL_SEARCH_TOKENS_SUCCESS, payload: [] });
  // const { addedTokens } = getState().createHPool;
  // const baseTokenName = getValueByMultiPropsLowerCased(getBaseToken(addedTokens), ['name', 'token_name']);
  // const modifiedTokenAtAdd = addedTokens.find((token) => token.percentage > token.min);
  // modifiedTokenAtAdd.percentage -= 1;

  const mapToTokenId = { ...token, token_id: token.id, percentage: 0, min: 1 };
  const tokensAfterAdd = [...getState().createHPool.addedTokens, { ...mapToTokenId }];

  // simulate adding 1% to the new token
  const payload = createHPoolHandleTokenPercentageChange(mapToTokenId, 1, tokensAfterAdd);
  dispatch({ type: CREATE_HPOOL_ADD_TOKEN, payload });
};
/**
 * Handles when the user changes a tokens percentage in create choose tokens step
 *
 * @param newVal {Number}
 * @param changedToken {Object}
 * @returns {(function(*, *): void)|*}
 */
export const createHPoolHandleTokenPercentageChangeAction = (newVal, changedToken) => (dispatch, getState) => {
  console.log('token change', newVal, changedToken);
  const payload = createHPoolHandleTokenPercentageChange(changedToken, newVal, getState().createHPool.addedTokens);
  console.log('payload after token change', payload);
  dispatch({ type: CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE, payload });
};

export const replaceHpoolAddedTokens = (modifiedTokens) => (dispatch) => {
  dispatch({ type: MANAGE_HPOOL_REPLACE_TOKENS, payload: modifiedTokens });
};

/**
 * Handles when the user clicks on the slider tokens lock icon
 *
 * @param token {Object}
 * @returns {(function(*, *))|*}
 */
export const createHPoolHandleTokenLockUnlockAction = (token) => (dispatch, getState) => {
  const addedTokens = [...getState().createHPool.addedTokens];
  const changedTokenIndex = addedTokens.findIndex((addedToken) => findTokenToAddConditional(token, addedToken));
  addedTokens[changedTokenIndex].locked = !token.locked;

  dispatch({ type: CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE, payload: addedTokens });
};

// export const createHPoolAddTokenFromSearchAction = (token) => async (dispatch, getState, isUnsaved = false) => {
//   dispatch(setCreateHPoolChooseTokensSearchAction(''));
//   dispatch({ type: CREATE_HPOOL_SEARCH_TOKENS_SUCCESS, payload: [] });

//   const payload = [...getState().createHPool.unsavedToken, { ...token, percentage: 0 }];
//   if (isUnsaved) {
//     dispatch({ type: CREATE_HPOOL_ADD_TOKEN_UNSAVED, payload });
//   } else {
//     dispatch({ type: CREATE_HPOOL_ADD_TOKEN, payload });
//   }
// };

/**
 * Handles when the user clicks on the slider delete lock icon
 *
 * @param token {Object}
 * @returns {(function(*, *))|*}
 */
export const createHPoolHandleTokenDeleteAction = (token) => (dispatch, getState) => {
  const payload = createHPoolHandleTokenDelete(token, getState().createHPool.addedTokens);
  dispatch({ type: CREATE_HPOOL_DELETE_TOKEN, payload });
};

/**
 * Gets user's nft image
 *
 * @param token {Object}
 * @returns {(function(*, *))|*}
 */
export const getChampionNftImageAction = (token) => async (dispatch) => {
  dispatch({ type: GET_CHAMPION_NFT_IMAGE_REQUEST });

  try {
    const payload = getChampionNftImage();

    dispatch({ type: GET_CHAMPION_NFT_IMAGE_SUCCESS, payload });
  } catch (err) {
    dispatch({ type: GET_CHAMPION_NFT_IMAGE_FAILURE, payload: err.message });
  }
};

export const updateChampionUnattachedNFTAction = () => async (dispatch, getState) => {
  dispatch({ type: UPDATE_CHAMPION_NFT_REQUEST });

  try {
    const payload = await updateChampionUnattachedNFT(getState().champion.championData?.champion_id);

    dispatch({ type: UPDATE_CHAMPION_NFT_SUCCESS, payload });
  } catch (err) {
    dispatch({ type: UPDATE_CHAMPION_NFT_FAILURE, payload: err.message });
  }
};

/**
 * Handles when the user clicks the skip button on the deposit funds step
 *
 * @param history {Object}
 * @returns {(function(*, *): Promise<*>)|*}
 */
export const createHPoolSkipAction = (history) => async (dispatch, getState) => {
  const hPoolId = getState().createHPool.hpool?.id;
  if (getState().createHPool.hpool?.id) {
    history.push(`/hpool/${hPoolId}`);
  } else {
    history.push(`/champion/${getState().champion.championData.handle}`);
  }
};

/**
 * Handles the redux state for calculating the usd limit on deposit funds
 *
 * @param assetSymbol {String}
 * @returns {(function(*): Promise<string|*>)|*}
 */
const getCreateHPoolDepositFundsLimitAction = (assetSymbol) => async (dispatch) => {
  const promises = [dispatch(getAssetBalanceAction('ETH')), dispatch(getAssetPriceAction(assetSymbol, 'USD'))];

  const [ethBalance, ethUsdPrice] = await Promise.all(promises);

  const limit = Dec(ethBalance).times(ethUsdPrice);
  if (limit.gt(MAX_POOL_ALLOCATION)) return MAX_POOL_ALLOCATION;

  return limit.toString();
};

/**
 * Handles the redux state for fetching data needed on the deposit funds step
 *
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const getCreateHPoolDepositFundsDataAction = () => async (dispatch) => {
  dispatch({ type: GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST });

  try {
    const usdLimit = await dispatch(getCreateHPoolDepositFundsLimitAction('ETH'));

    dispatch({ type: GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS, payload: usdLimit });
  } catch (err) {
    dispatch({ type: GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE, payload: err.message });
  }
};

/**
 * Handles the redux state for getting tags list on the pool info step
 *
 * @param searchStr {String}
 * @returns {(function(*, *): void)|*}
 */
export const getTagsAction = (searchStr) => async (dispatch) => {
  dispatch({ type: GET_TAGS_REQUEST });

  try {
    const payload = await getTags(searchStr);

    dispatch({ type: GET_TAGS_SUCCESS, payload });
  } catch (err) {
    dispatch({ type: GET_TAGS_FAILURE, payload: err.message });
  }
};

/**
 * Handles the redux state for updating selected tags on the pool info step
 *
 * @param searchStr {String}
 * @returns {(function(*, *): void)|*}
 */
export const updateTagsAction = (tags) => async (dispatch) => {
  dispatch({ type: UPDATE_TAGS, payload: tags });
};

export const getHPoolAction = (id) => async (dispatch) => {
  dispatch(startAction());
  dispatch({ type: GET_HPOOL_REQUEST });

  try {
    const response = await getHPool(id);
    const { hpool, stats, nft_image: nftImage } = response;
    const tradeOrders = response?.pending_market_trade_orders || response.trade_orders;
    // TODO Mohammed we need to ask user to sign tradeorders if there are any pendings
    /*
    if (response?.pending_market_trade_orders) {
      dispatch(openEditTokensModal({ stage: UPDATED_HPOOL_LIST_STAGE, pendingTradeOrders: response?.pending_market_trade_orders }));
    }
     */

    const hpoolWithNftImage = {
      ...hpool,
      stats,
      nftImage,
    };

    const payload = {
      hpool: hpoolWithNftImage,
      tradeOrders,
    };
    dispatch({ type: GET_HPOOL_SUCCESS, payload, id });
  } catch (err) {
    dispatch(createNotification('error', err, 4000));
  } finally {
    dispatch(stopAction());
  }
};

export const setAssetSigantures = (assetSignatures) => ({ type: SET_ASSET_SIGNATURES, payload: assetSignatures });

export const setCurrentTab = (tab) => (dispatch) => {
  dispatch({ type: SET_CURRENT_TAB, payload: tab });
};

export const getWhitelistedPools = (account) => async (dispatch, getState) => {
  try {
    const { address_whitelisted_for_vpools: whitelistedPools = [] } = (await getWhitelistedPoolsForUser(account)) || {};
    return dispatch({ type: SET_WHITELISTED_POOLS, payload: whitelistedPools });
  } catch (error) {
    dispatch(createNotification('error', error?.message, 4000));
  }
};

export const setIsVpoolFlag = (isVpool) => (dispatch, getState) => {
  dispatch({ type: SET_VPOOL_FLAG, payload: isVpool });
};

export const getSaftsAction = (poolId) => async (dispatch, getState) => {
  try {
    const passesdPoolId = poolId || getState().createHPool?.hpool?.id; // you don't have to pass pool id in case u in creation flow or pool view
    dispatch({ type: GET_HPOOL_SAFTS_REQUEST });

    const safts = (await getPoolSafts(passesdPoolId)) ?? [];
    dispatch({ type: GET_HPOOL_SAFTS_SUCCESS, payload: safts });
  } catch (error) {
    dispatch({ type: GET_HPOOL_SAFTS_FAILURE, payload: error.message });
  }
};
